import * as React from "react";

export default function Notfound() {
  return <div>404 : Page doesn't exist</div>;
}
